import React, { Component } from "react";
import QRCode from 'qrcode.react';

import CopyCell from "./CopyCell";

import utils from "../../../utils";

let appHasWeixin = 0;   // app 是否安装微信

class FooterShare extends Component {

    constructor(props) {
        super(props);

        this.state = {
            posterUrl: props && props.posterUrl ? props.posterUrl : "",
            linkUrl: props && props.landingPageUrl ? props.landingPageUrl : "",
            qrcodeList: [0, 0, 0, 0]
        }

        this.handleCopy = this.handleCopy.bind(this);
    }

    componentWillMount() {
        window.weChatWhetherInstalled = function (id) {
            appHasWeixin = parseInt(id, 10);
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.posterUrl) {
            this.setState({
                posterUrl: nextProps.posterUrl
            });
        }
    }

    // 点击分享项单元
    handleClickShare(value, index) {
        const that = this;
        const { posterUrl } = this.state;

        let shareObj = {
            "session": 0,    //0表示好友，1表示朋友圈
            "imgUrl": posterUrl,
            "shareType": 1
        }
        let imgObj = {
            "imgUrl": posterUrl
        }
        // 防止获取不到是否安装了微信，点击的时候再调一次是否安装微信的方法
        if (window.getAppHasWeixin) {
            appHasWeixin = window.getAppHasWeixin() ? parseInt(window.getAppHasWeixin(), 10) : appHasWeixin;
        } else if (window.android && window.android.getAppHasWeixin) {
            appHasWeixin = window.android.getAppHasWeixin() ? parseInt(window.android.getAppHasWeixin(), 10) : appHasWeixin;
        }

        // IOS 是调用 getAppHasWeixin 方法之后，再回调 js 的 weChatWhetherInstalled 方法，这是异步的。直接使用会存在还没有回调，下面的代码就执行了，因此添加一个定时器。
        setTimeout(() => {
            // 分享和保存
            if (value) {
                if (value.key === "timeline") {      // 分享到朋友圈
                    if (value.realUA === "isPC") {
                        if (value.pcFunction && typeof value.pcFunction === "function") {
                            value.pcFunction();
                            return;
                        }
                    }
                    if (value.appFunction && typeof value.appFunction === "function") {
                        value.appFunction();
                    }
                    shareObj.session = 1;
                    that.handleShareWechat(shareObj, index);
                }

                if (value.key === "friend") {    // 分享给微信好友
                    shareObj.session = 0;
                    that.handleShareWechat(shareObj, index);
                }

                if (value.key === "save") {     // 保存图片
                    utils.callApp({
                        name: "saveImageToPhotosAlbum",
                        param: JSON.stringify(imgObj)
                    });
                }
            }
        }, 100);
    }

    // 分享到微信
    handleShareWechat(shareObj, index) {
        let { qrcodeList } = this.state;

        if (appHasWeixin) {
            utils.callApp({
                name: "weChatShare",
                param: JSON.stringify(shareObj)
            });
        } else {
            qrcodeList = qrcodeList.map((value, i) => i === index ? 1 : 0);
            this.setState({ qrcodeList: qrcodeList });
        }
    }

    // 点击复制
    handleCopy() {
        this.setState({
            copied: true
        });
        utils.showTips("复制成功！");
    }

    render() {
        const that = this;
        const { shareConfig } = this.props;
        const { showQrcode, linkUrl, qrcodeList } = that.state;

        return (
            <div className={shareConfig && shareConfig.length && shareConfig.length === 1 ? "footer-share single" : "footer-share"}>
                {shareConfig && Array.isArray(shareConfig) && shareConfig.map((value, index) => {
                    return value.key && value.key === "save" && !utils.publicVar.isApp ? null
                        : <CopyCell {...this.state}
                            key={index}
                            value={value}
                            handleCopy={that.handleCopy}>
                            <div key={index}
                                className={`share-cell ${value.key}`}
                                onClick={() => that.handleClickShare(value, index)}
                            >
                                <div className="share-cell-logo" />
                                <div className="share-cell-text">{value.text}</div>
                                {qrcodeList && Array.isArray(qrcodeList) && qrcodeList[index] ?
                                    <div className="share-cell-qrcode">
                                        <QRCode value={linkUrl} />
                                    </div>
                                    : null
                                }
                            </div>
                        </CopyCell>
                })}
                {showQrcode && <QRCode value={linkUrl} />}
            </div>
        );
    }
}

export default FooterShare;




// WEBPACK FOOTER //
// ./src/lib/components/InvitePoster/components/footerShare.js